import MiddlewareConnector from './middleware-connector'

/**
 * A JavaScript plugin for Vue.js projects that provides an easy-to-use interface for interacting with middleware endpoints.
 */
const MiddlewareConnectorPlugin = {

    /** @type {MiddlewareConnector} */
    instance: undefined,

    /**
     * Installs the MiddlewareConnectorPlugin and initializes the middleware connector instance with the provided configuration.
     *
     * @param {import('vue').App} app The Vue.js application instance.
     * @param {Object} options  Options for initializing the plugin.
     * @param {string} options.middlewareUrl The url of the middleware server.
     * @throws {Error} Throws an error if no middlewareUrl is provided.
     * @returns {void}
     */
    install(app, options) {
        if (!options?.middlewareUrl) {
            throw new Error('No middleware url provided')
        }

        this.instance = new MiddlewareConnector(options.middlewareUrl)
    }
}

const useMiddlewareConnector = () => MiddlewareConnectorPlugin.instance

export default MiddlewareConnectorPlugin

export {
    useMiddlewareConnector
}